import { authFetch, BASE_BACKEND_URL } from '../../../auth'
import cookie from 'react-cookies'
import { getCurrentDate } from '../../../helpers/formatDate'
import { ReportTabsMap, ReportTabLabels } from './reportTabs'

export async function downloadUserReportCsv({
  csvType,
  startDate,
  endDate,
  searchQuery = '',
  activeTabKey,
  filenameLabelOverride,
  hasPendingSettlementQuery = ''
}) {
  if (!csvType) {
    alert('Descarga no disponible para este tab.')
    return
  }

  const supervisorName = cookie.load('user_name')
  const businessName = cookie.load('business_name')

  const url = `${BASE_BACKEND_URL}/reports/user_reports/download_csv/${csvType}?start_date=${startDate}&end_date=${endDate}&supervisor_name=${encodeURIComponent(supervisorName)}&search=${encodeURIComponent(searchQuery || '')}${hasPendingSettlementQuery || ''}`

  try {
    const res = await authFetch(url, { method: 'GET' })

    if (!res) return

    if (!res.ok) {
      alert('Error al generar el archivo.')
      return
    }

    const blob = await res.blob()
    const link = document.createElement('a')
    const blobUrl = window.URL.createObjectURL(blob)
    link.href = blobUrl
    const tabLabel =
      filenameLabelOverride || ReportTabLabels[ReportTabsMap[activeTabKey]] || activeTabKey
    link.download = `ReporteUsuarios${tabLabel}_${businessName}_${getCurrentDate()}.csv`
    link.click()
    window.URL.revokeObjectURL(blobUrl)
  } catch (err) {
    console.error('Error al descargar CSV:', err)
    alert('Error al descargar el archivo.')
  }
}
